<template>
  <section class="token">
    <!--    <section class="token h-170-screen lg:h-140-screen">-->
    <div class="mb-0 lg:mb-120 overflow-hidden">
      <div class="token-wrapper">
        <div class="blex w-full pt-0 lg:pt-80 pb-0 lg:pb-40">
          <div class="text-white font-bold text-2xl lg:text-6xl blex pt-80 lg:pt-200 bottom-gradient pb-12 z-5">
            TOKEN
          </div>
        </div>

        <!--  token     -->
        <div
            style="z-index: 2;"
            class="flex justify-between items-center flex-wrap lg:flex-no-wrap pt-40 pb-40 px-16 lg:px-0 w-full lg:w-7/10">

          <div class="gradient"></div>

          <!--    mct token      -->
          <div
              @mouseover="isMct = true"
              @mouseout="isMct = false"
              class="mr-0 lg:mr-80"
              style="z-index: 15;"
          >
            <div class="blex">
              <kinesis-container style="z-index: 10;">
                <div
                    class="relative"
                >
                  <kinesis-element
                      :strength="$store.state.windowWidth > 1024 ? 20 : 0"
                      tag="img"
                      type="depth"
                      :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/token/redToken.png') : require('@/assets/images/pages/main/token/mRedToken.png')"
                      style="z-index: 15;"
                  />
                  <div class="red-stone">
                    <div class="red-crystal"></div>
                    <div class="red-crystal2"></div>
                  </div>
                  <div class="red-gradient"
                       :class="isMct ? 'on' : '' ">
                  </div>
                  <div class="mct-gradient"
                       :class="isMct ? 'on' : '' "
                  ></div>
                </div>
              </kinesis-container>
            </div>
            <div class="blex relative">
              <div class="blex">
                <img src="@/assets/images/pages/main/token/mct.png" class="mct-logo">
              </div>
              <div class="text-white font-bold text-lg lg:text-4xl py-20 lg:pt-32 lg:pb-40 ml-12">
                MCT
              </div>
            </div>
            <div
                class="g-opacity token-desc">
              {{ $t('token.1') }}
              {{ $t('token.2') }}
              {{ $t('token.3') }}
              {{ $t('token.4') }}
              {{ $t('token.5') }}
            </div>
          </div>

          <!--  mrg token        -->
          <div
              @mouseover="isMrg = true"
              @mouseout="isMrg = false"
              style="z-index: 15;"
          >
            <div class="blex">
              <kinesis-container style="z-index: 10;">
                <div
                    class="relative"
                >
                  <kinesis-element
                      :strength="$store.state.windowWidth > 1024 ? 20 : 0"
                      tag="img"
                      type="depth"
                      :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/token/blueToken1.png') : require('@/assets/images/pages/main/token/mBlueToken.png')"
                      style="z-index: 15;"
                  />
                  <div class="blue-stone">
                    <div class="blue-crystal"></div>
                    <div class="blue-crystal2"></div>
                  </div>
                  <div class="blue-gradient"
                       :class="isMrg ? 'on' : ''">
                  </div>
                  <div class="mrg-gradient"
                       :class="isMrg ? 'on' : ''"
                  ></div>
                </div>
              </kinesis-container>
            </div>
            <div class="blex relative z-10">
              <div>
                <img src="@/assets/images/pages/main/token/mrg.png" class="mrg-logo">
              </div>
              <div class="text-white font-bold text-lg lg:text-4xl py-20 lg:pt-32 lg:pb-40 ml-12">
                MRG
              </div>
            </div>
            <div
                class="g-opacity token-desc">
              {{ $t('token.6') }}
              {{ $t('token.7') }}
              {{ $t('token.8') }}
              {{ $t('token.9') }}
              {{ $t('token.10') }}
            </div>
          </div>

        </div>

        <!-- tree    -->
        <div>

          <!-- left tree @todo : scroll 시 'on' animation 적용       -->
          <div class="left-tree">
            <img src="@/assets/images/pages/main/token/leftTree.svg" alt="" class="w-full">
          </div>
          <!-- right tree @todo : scroll 시 'on' animation 적용       -->
          <div class="right-tree">
            <img src="@/assets/images/pages/main/token/rightTree.svg" alt="" class="w-full">
          </div>

        </div>

        <!--   gradient       -->
        <div class="left-gradient"></div>
        <div class="right-gradient"></div>
      </div>
    </div>
  </section>
</template>

<script>
let timeline = null
export default {
  name: 'Token',
  data: () => ({
    isMrg: false,
    isMct: false,
    timer: null
  }),
  methods: {
    animations() {
      timeline = this.$gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: 'section.token',
          scroller: '#index',
          start: 'top',
          end: '20%',
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      }).fromTo('.left-tree', {
        x: '-100%'
      }, {
        duration: 1,
        x: 0
      }).fromTo('.right-tree', {
        x: '100%'
      }, {
        x: 0
      }, '-=1')

      this.$gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: '.g-opacity',
          scroller: '#index',
          start: '50% 90%',
          end: 'bottom 80%',
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      }).fromTo('.g-opacity', {
        opacity: 0
      }, {
        opacity: 1
      })

      // this.$scrollTrigger.refresh()
    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }

    if (timeline) {
      timeline.kill()
    }
  }
}
</script>

<style scoped lang="scss">
section::v-deep {
  .token-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    //background: #000000;
    @media screen and (max-width: 1024px) {
      height: auto;
    }

    .gradient {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, 1) 30%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 1) 100%);
      //background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 1) 15%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 1) 100%);
      //background: -moz-linear-gradient(180deg, rgba(0, 0, 0, 1) 15%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 1) 100%);
      //background: -o-linear-gradient(180deg, rgba(0, 0, 0, 1) 15%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 1) 100%);
      z-index: 10;
      @media screen and(max-width: 1024px) {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0) 100%);
      }

    }

    .token-desc {
      min-width: 250px;
      max-width: 500px;
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      position: relative;
      z-index: 10;

      @media screen and (max-width: 1024px) {
        font-size: 13px;
        line-height: 20px;
        width: 100%;
      }
    }

    .mct-logo {

      @media screen and (max-width: 1024px) {
        width: 24px;
        height: 24px;
      }
    }

    .mrg-logo {
      @media screen and (max-width: 1024px) {
        width: 24px;
        height: 24px;
      }
    }

    .red-gradient {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
      background-image: url("~@/assets/images/pages/main/token/bgRed3.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;

      &.on {
        animation: pulse 1.8s linear infinite;
      }
    }

    .mct-gradient {
      position: absolute;
      border-radius: 50%;
      left: 35%;
      top: 50%;
      transform: translate(-35%, -50%);
      width: 200px;
      height: 200px;
      background: transparent;
      filter: blur(0);
      z-index: -1;
      transform: matrix(-1, 0, 0, 1, 0, 0);

      &.on {
        animation: pulse2 .1s linear forwards;
      }

    }

    @keyframes pulse2 {
      0% {
        background: transparent;
        filter: blur(0);
      }
      100% {
        background: #B10109;
        filter: blur(60px);

      }

    }


    .blue-gradient {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      background-image: url("~@/assets/images/pages/main/token/bgBlue8.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;

      &.on {
        animation: pulse 1.8s linear infinite;
      }
    }

    .mrg-gradient {
      position: absolute;
      border-radius: 50%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 200px;
      height: 200px;
      background: transparent;
      filter: blur(0);
      z-index: -1;
      transform: matrix(-1, 0, 0, 1, 0, 0);

      &.on {
        animation: pulse3 .1s linear forwards;
      }

    }

    @keyframes pulse3 {
      0% {
        background: transparent;
        filter: blur(0);
      }
      100% {
        background: #1279B7;
        filter: blur(60px);

      }

    }


    @keyframes pulse {
      0% {
        transform: scale(.5) perspective(500px) translate3d(0, 0, 0);
        opacity: 0;

      }
      50% {
        transform: scale(1.2) perspective(1000px) translate3d(0, 0, 100px);
        opacity: 1;
      }

      100% {
        transform: scale(1.5) perspective(2000px) translate3d(0, 0, 300px);
        opacity: 0;
      }

    }

    .red-stone {
      position: absolute;
      white-space: nowrap;
      top: 0;
      left: 50%;
      width: 500px;
      transform: translate(-50%);
      height: 100vh;
      background: transparent;
      z-index: -1;
      @media screen and(max-width: 1024px) {
        width: 100vw;

      }

      .red-crystal {
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url("~@/assets/images/pages/main/token/redStone.png");
        background-repeat: repeat-y;
        background-position-x: center;
        background-size: cover;
        animation: up 15s linear infinite;

        @media screen and(max-width: 1024px) {
          width: 100%;
          height: 50%;
          top: 0;
        }
      }

      @keyframes up {
        0% {
          background-position: 0 0;
          //transform: translateY(0);
        }
        100% {
          //transform: translateY(-100vh);
          background-position: 0 100vh;
        }
      }

      .red-crystal2 {
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url("~@/assets/images/pages/main/token/redStone2.png");
        background-repeat: repeat-y;
        background-position-x: center;
        background-size: cover;
        animation: up 20s linear infinite;
        @media screen and(max-width: 1024px) {
          background-image: url("~@/assets/images/pages/main/token/mRedStone3.png");
          height: 50%;
          top: 0;
        }
      }
    }

    .blue-stone {
      position: absolute;
      top: 0;
      right: 50%;
      width: 500px;
      height: 100vh;
      background: transparent;
      transform: translate(50%);
      z-index: -1;
      @media screen and(max-width: 1024px) {
        width: 100vw;

      }

      .blue-crystal {
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url("~@/assets/images/pages/main/token/blueStone.png");
        background-repeat: repeat-y;
        background-position-x: center;
        background-size: cover;
        animation: up 15s linear infinite;
        @media screen and(max-width: 1024px) {
          height: 100%;
          bottom: 0;
        }
      }

      .blue-crystal2 {
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url("~@/assets/images/pages/main/token/blueStone2.png");
        background-repeat: repeat-y;
        background-position-x: center;
        background-size: cover;
        animation: up 20s linear infinite;
        @media screen and(max-width: 1024px) {
          background-image: url("~@/assets/images/pages/main/token/mBlueStone2.png");
          height: 100%;
          bottom: 0;
        }
      }
    }


    .left-tree {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;

      &.on {
        animation: leftToRight 2s 0s linear forwards;
      }

      @keyframes leftToRight {
        0% {
          left: -100%;
          top: -100%;
        }
        100% {
          left: 0;
          top: 0;
        }
      }
      @media screen and (max-width: 1024px) {
        width: 122px;
        height: 117px;
      }
    }

    .right-tree {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;

      &.on {
        animation: rightToLeft 2s 0s linear forwards;
      }

      @keyframes rightToLeft {
        0% {
          right: -100%;
          top: -100%;
        }
        100% {
          right: 0;
          top: 0;
        }
      }

      @media screen and (max-width: 1024px) {
        width: 122px;
        height: 117px;
      }
    }

    .left-gradient {
      position: absolute;
      border-radius: 50%;
      left: -10%;
      top: 35%;
      width: 350px;
      height: 350px;
      background: #B10109;
      filter: blur(150px);
      transform: matrix(-1, 0, 0, 1, 0, 0);
      @media screen and (max-width: 1024px) {
        display: none;
        left: -50%;
        top: 0;
        &.on {
          display: block;
        }
      }
    }

    .right-gradient {
      position: absolute;
      right: -10%;
      top: 35%;
      border-radius: 50%;
      width: 350px;
      height: 350px;
      background: #1279B7;
      filter: blur(150px);
      -webkit-filter: blur(150px);
      transform: matrix(-1, 0, 0, 1, 0, 0);
      z-index: 0;
      @media screen and (max-width: 1024px) {
        display: none;
        right: -20%;
        top: 60%;

        &.on {
          display: block;
        }

      }
    }
  }

}

</style>
